import Logger from 'forms-utils-lib/logger/Logger';
import { FormStatus, FormType } from './types';
import I18n from 'I18n';
import { PROPERTIES } from './constants';
export const formStatusToI18nText = (formStatus, formType, nonHubSpotFormsTurnedOn) => {
  switch (formType) {
    case FormType.CAPTURED:
      {
        return nonHubSpotFormsTurnedOn ? I18n.text('dashboard.frameworkTable.columns.name.status.active') : I18n.text('dashboard.frameworkTable.columns.name.status.default');
      }
    default:
      {
        switch (formStatus) {
          case FormStatus.DRAFT:
            return I18n.text('dashboard.frameworkTable.columns.name.status.draft');
          case FormStatus.PUBLISHED:
            return I18n.text('dashboard.frameworkTable.columns.name.status.published');
          default:
            Logger.error(`Failed to convert FormStatus to a I18n text: ${formStatus}`);
            return I18n.text('dashboard.frameworkTable.columns.name.status.default');
        }
      }
  }
};
export const formTypeToI18nText = (formType, ungatedForNewEditorAccess) => {
  switch (formType) {
    case FormType.HUBSPOT:
      if (ungatedForNewEditorAccess) {
        return I18n.text('dashboard.frameworkTable.columns.name.formType.form');
      } else {
        return I18n.text('dashboard.frameworkTable.columns.name.formType.hubspot');
      }
    case FormType.CAPTURED:
      return I18n.text('dashboard.frameworkTable.columns.name.formType.captured');
    case FormType.BLOG_COMMENT:
      return I18n.text('dashboard.frameworkTable.columns.name.formType.blogComment');
    case FormType.FLOW:
      return I18n.text('dashboard.frameworkTable.columns.name.formType.flow');
    case FormType.TICKET_FORM:
      return I18n.text('dashboard.frameworkTable.columns.name.formType.ticketForm');
    case FormType.VIDEO_FORM:
      return I18n.text('dashboard.frameworkTable.columns.name.formType.videoForm');
    case FormType.FACEBOOK_LEAD_AD:
      return I18n.text('dashboard.frameworkTable.columns.name.formType.facebookLeadAd');
    default:
      Logger.error(`Failed to convert FormType to a I18n text: ${formType}`);
      if (!formType) {
        return I18n.text('dashboard.frameworkTable.columns.name.formType.hubspot');
      }
      return I18n.text('dashboard.frameworkTable.columns.name.formType.unknown');
  }
};
export const updateCRMObjectPublishState = (crmObject, newPublishState) => {
  const properties = Object.assign({}, crmObject.properties, {
    [PROPERTIES.STATUS]: {
      value: newPublishState
    },
    [PROPERTIES.UPDATED_AT]: {
      value: String(I18n.moment().valueOf())
    }
  });
  return Object.assign({}, crmObject, {
    properties
  });
};
export const updateCRMObjectName = (crmObject, name) => {
  const properties = Object.assign({}, crmObject.properties, {
    [PROPERTIES.NAME]: Object.assign({}, crmObject.properties[PROPERTIES.NAME], {
      value: name
    })
  });
  return Object.assign({}, crmObject, {
    properties
  });
};